module.exports = __webpack_public_path__ + "img/open.a68b54b6.png";